export function sortJudgingPosts(groups, jumps, levels) {
    const jumpById = new Map(jumps.map((jump) => [jump.id, jump]));
    const levelById = new Map(levels.map((level) => [level.id, level]));
    const keyByGroupId = new Map(groups.map((group) => [group.id, judgingPostOrderKey(group, jumpById, levelById)]));
    return groups.slice().sort((a, b) => {
        const aKey = keyByGroupId.get(a.id);
        const bKey = keyByGroupId.get(b.id);
        return (aKey.runOrder - bKey.runOrder ||
            aKey.jumpCardinality - bKey.jumpCardinality ||
            aKey.displayOrder - bKey.displayOrder ||
            aKey.jumpNumber.localeCompare(bKey.jumpNumber, undefined, {
                numeric: true,
            }) ||
            a.id.localeCompare(b.id));
    });
}
function judgingPostOrderKey(group, jumpById, levelById) {
    const firstJump = group.jumpIds
        .map((jumpId) => jumpById.get(jumpId))
        .filter((jump) => !!jump)
        .sort((a, b) => {
        const byRunOrder = (levelById.get(a.levelId)?.runOrder ?? 9999) - (levelById.get(b.levelId)?.runOrder ?? 9999);
        if (byRunOrder !== 0)
            return byRunOrder;
        const byDisplayOrder = a.displayOrder - b.displayOrder;
        if (byDisplayOrder !== 0)
            return byDisplayOrder;
        return a.number.localeCompare(b.number, undefined, { numeric: true });
    })[0];
    if (!firstJump) {
        return {
            runOrder: 9999,
            jumpCardinality: Number.MAX_SAFE_INTEGER,
            displayOrder: Number.MAX_SAFE_INTEGER,
            jumpNumber: '',
        };
    }
    const cardinalityMatch = /^\s*(\d+)/.exec(firstJump.number);
    return {
        runOrder: levelById.get(firstJump.levelId)?.runOrder ?? 9999,
        jumpCardinality: cardinalityMatch ? Number(cardinalityMatch[1]) : Number.MAX_SAFE_INTEGER,
        displayOrder: firstJump.displayOrder,
        jumpNumber: firstJump.number,
    };
}
//# sourceMappingURL=judgingPostOrder.js.map